import React, { useEffect, useState } from 'react';
import { Search, Menu, X, ChevronDown, ChevronRight, User, ShoppingBag, Phone, Truck, Mail, ShoppingCart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface HeaderProps {
  onOpenSampleModal?: () => void;
}
export function Header({
  onOpenSampleModal
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPath, setCurrentPath] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  // Searchable product catalog
  const searchableItems = [
  // Products by SKU and variation
  {
    label: 'Asset Labels – PVC No Laminate 60×40mm',
    sku: '41138',
    keywords: 'pvc white no laminate 60x40 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – PVC No Laminate 50×25mm',
    sku: '41139',
    keywords: 'pvc white no laminate 50x25 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – PVC No Laminate 40×20mm',
    sku: '41140',
    keywords: 'pvc white no laminate 40x20 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – PVC Gloss 60×40mm',
    sku: '41141',
    keywords: 'pvc white gloss laminate 60x40 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – PVC Gloss 50×25mm',
    sku: '41142',
    keywords: 'pvc white gloss laminate 50x25 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – PVC Gloss 40×20mm',
    sku: '41143',
    keywords: 'pvc white gloss laminate 40x20 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – PVC Matt 60×40mm',
    sku: '41144',
    keywords: 'pvc white matt laminate 60x40 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – PVC Matt 50×25mm',
    sku: '41145',
    keywords: 'pvc white matt laminate 50x25 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – PVC Matt 40×20mm',
    sku: '41146',
    keywords: 'pvc white matt laminate 40x20 asset barcode duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester White Gloss 60×40mm',
    sku: '41147',
    keywords: 'polyester white gloss 60x40 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester White Gloss 50×25mm',
    sku: '41148',
    keywords: 'polyester white gloss 50x25 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester White Gloss 40×20mm',
    sku: '41149',
    keywords: 'polyester white gloss 40x20 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester White Matt 60×40mm',
    sku: '41150',
    keywords: 'polyester white matt 60x40 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester White Matt 50×25mm',
    sku: '41151',
    keywords: 'polyester white matt 50x25 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester White Matt 40×20mm',
    sku: '41152',
    keywords: 'polyester white matt 40x20 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester Silver Gloss 60×40mm',
    sku: '41153',
    keywords: 'polyester silver gloss 60x40 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester Silver Gloss 50×25mm',
    sku: '41154',
    keywords: 'polyester silver gloss 50x25 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester Silver Gloss 40×20mm',
    sku: '41155',
    keywords: 'polyester silver gloss 40x20 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester Silver Matt 60×40mm',
    sku: '41156',
    keywords: 'polyester silver matt 60x40 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester Silver Matt 50×25mm',
    sku: '41157',
    keywords: 'polyester silver matt 50x25 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Polyester Silver Matt 40×20mm',
    sku: '41158',
    keywords: 'polyester silver matt 40x20 asset duralabel',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Mark Resist 60×40mm',
    sku: '41159',
    keywords: 'mark resist anti-graffiti 60x40 asset duralabel pvc',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Mark Resist 50×25mm',
    sku: '41160',
    keywords: 'mark resist anti-graffiti 50x25 asset duralabel pvc',
    href: '/products/asset-labels',
    category: 'Product'
  }, {
    label: 'Asset Labels – Mark Resist 40×20mm',
    sku: '41161',
    keywords: 'mark resist anti-graffiti 40x20 asset duralabel pvc',
    href: '/products/asset-labels',
    category: 'Product'
  },
  // Product types
  {
    label: 'Asset Barcode Labels',
    sku: '',
    keywords: 'asset barcode identification tracking',
    href: '/products/asset-labels',
    category: 'Product Type'
  }, {
    label: 'Property Of Labels',
    sku: '',
    keywords: 'property of ownership identification',
    href: '/products/asset-labels',
    category: 'Product Type'
  }, {
    label: 'Asset QR Labels',
    sku: '',
    keywords: 'asset qr code digital tracking',
    href: '/products/asset-labels',
    category: 'Product Type'
  }, {
    label: 'Tamper Evident & Security Labels',
    sku: '',
    keywords: 'tamper evident security void',
    href: '/products/tamper-evident-labels',
    category: 'Product Type'
  }, {
    label: 'Logo / Brand Labels',
    sku: '',
    keywords: 'logo brand custom branding',
    href: '/products/logo-brand-labels',
    category: 'Product Type'
  }, {
    label: 'Nameplates',
    sku: '',
    keywords: 'nameplate metal aluminium rating plate',
    href: '/products/nameplates',
    category: 'Product Type'
  },
  // Pages
  {
    label: 'About Us',
    sku: '',
    keywords: 'about company history heritage',
    href: '/about',
    category: 'Page'
  }, {
    label: 'Meet the Team',
    sku: '',
    keywords: 'team staff people',
    href: '/team',
    category: 'Page'
  }, {
    label: 'Sectors & Industries',
    sku: '',
    keywords: 'sectors industries manufacturing automotive defence',
    href: '/services',
    category: 'Page'
  }, {
    label: 'Resources & Artwork Guidelines',
    sku: '',
    keywords: 'resources artwork guidelines templates',
    href: '/resources',
    category: 'Page'
  }, {
    label: 'Delivery Information',
    sku: '',
    keywords: 'delivery shipping dispatch how we deliver',
    href: '/how-we-deliver',
    category: 'Page'
  }, {
    label: 'Policies & FAQs',
    sku: '',
    keywords: 'policies faq returns terms conditions',
    href: '/policies',
    category: 'Page'
  }, {
    label: 'Asset Labels – Simplified Builder',
    sku: '',
    keywords: 'simplified builder quick order easy',
    href: '/simplified',
    category: 'Page'
  }];
  const searchResults = searchQuery.trim().length >= 2 ? searchableItems.filter(item => {
    const q = searchQuery.toLowerCase();
    return item.label.toLowerCase().includes(q) || item.sku.includes(q) || item.keywords.toLowerCase().includes(q);
  }).slice(0, 8) : [];
  const showSearchResults = isSearchFocused && searchQuery.trim().length >= 2;
  useEffect(() => {
    setCurrentPath(window.location.pathname);
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const productCategories = [{
    name: 'Identification Labels',
    href: '#',
    subItems: [{
      name: 'Asset Labels',
      href: '/products/asset-labels'
    }, {
      name: 'Asset Labels – Simplified',
      href: '/simplified'
    }, {
      name: 'Asset Labels - Micro QR',
      href: '/products/asset-labels-micro-qr'
    }, {
      name: 'Tamper Evident & Security Labels',
      href: '/products/tamper-evident-labels'
    }, {
      name: 'Logo/Brand Labels',
      href: '/products/logo-brand-labels'
    }]
  }, {
    name: 'Nameplates',
    href: '/products/nameplates'
  }];
  const handleSampleClick = (e: React.MouseEvent) => {
    if (onOpenSampleModal) {
      e.preventDefault();
      onOpenSampleModal();
      setIsMobileMenuOpen(false);
    }
  };
  const isActive = (path: string) => currentPath === path || currentPath.startsWith(path + '/');
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white'}`} data-id="element-176">
      {/* Top Announcement Bar */}
      <div className="bg-[#0A1628] text-white py-2.5" data-id="element-177">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-178">
          {/* Left - Free delivery + How we deliver link */}
          <div className="flex items-center gap-2 text-sm font-semibold tracking-wide" data-id="element-179">
            <Truck className="h-4 w-4 text-white" data-id="element-180" />
            <span className="hidden sm:inline" data-id="element-181">
              Free nationwide delivery on all orders
            </span>
            <span className="sm:hidden" data-id="element-182">Free delivery</span>
            <a href="/how-we-deliver" className="flex items-center justify-center h-5 w-5 rounded-full bg-white/15 hover:bg-white/30 transition-colors ml-1" title="How we deliver" data-id="element-183">
              <ChevronRight className="h-3 w-3 text-white" data-id="element-184" />
            </a>
          </div>

          {/* Center - Heritage text */}
          <div className="hidden lg:flex items-center gap-2 text-sm font-medium text-slate-300" data-id="element-185">
            <span data-id="element-186">🇬🇧</span>
            <span data-id="element-187">Family owned UK manufacturer, Est. 1999</span>
          </div>

          {/* Right - Email + divider + Phone */}
          <div className="hidden sm:flex items-center gap-3 text-sm" data-id="element-188">
            <a href="mailto:sales@industriallabels.co.uk" className="hidden lg:flex items-center gap-1.5 font-medium text-slate-300 hover:text-white transition-colors" data-id="element-189">
              <Mail className="h-3.5 w-3.5" data-id="element-190" />
              <span data-id="element-191">sales@industriallabelsandnameplates.co.uk</span>
            </a>
            <span className="hidden lg:block w-px h-4 bg-white/20" data-id="element-192"></span>
            <a href="tel:01384243155" className="flex items-center gap-1.5 font-bold text-slate-200 hover:text-white transition-colors" data-id="element-193">
              <Phone className="h-4 w-4" data-id="element-194" />
              <span data-id="element-195">01384 243155</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="border-b border-slate-100" data-id="element-196">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-4" data-id="element-197">
          <div className="flex items-center justify-between gap-8" data-id="element-198">
            {/* Logo */}
            <a href="/" className="flex-shrink-0" data-id="element-199">
              <img src="https://cdn.magicpatterns.com/uploads/15zvHmdnHQnbu23n1TkNf3/ILN.png" alt="Industrial Labels & Nameplates" className="h-14 md:h-16 w-auto object-contain" data-id="element-200" />
            </a>

            {/* Desktop Navigation - Pills style */}
            <nav className="hidden lg:flex items-center bg-slate-100 rounded-full px-1.5 py-1.5" data-id="element-201">
              <div className="relative" onMouseEnter={() => setActiveDropdown('products')} onMouseLeave={() => setActiveDropdown(null)} data-id="element-202">
                <button className={`flex items-center text-sm font-semibold px-4 py-2 rounded-full transition-all shadow-sm ${isActive('/products') ? 'bg-[#0052CC] text-white' : 'bg-white text-[#0A1628] hover:bg-[#0052CC] hover:text-white'}`} data-id="element-203">
                  Products
                  <ChevronDown className="ml-1 h-3.5 w-3.5" data-id="element-204" />
                </button>

                <AnimatePresence data-id="element-205">
                  {activeDropdown === 'products' && <motion.div initial={{
                  opacity: 0,
                  y: 8
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: 8
                }} transition={{
                  duration: 0.15
                }} className="absolute top-full left-0 mt-2 w-72 bg-white shadow-xl border border-slate-200 rounded-xl overflow-hidden p-2 z-50" data-id="element-206">
                      {productCategories.map(category => <div key={category.name} data-id="element-207">
                          {category.subItems ? <div data-id="element-208">
                              <div className="flex items-center justify-between px-3 py-2.5 text-xs font-bold text-slate-400 uppercase tracking-wider bg-slate-50 rounded-lg mb-1" data-id="element-209">
                                {category.name}
                              </div>
                              <div className="pl-2 space-y-0.5 mb-2 border-l-2 border-[#0052CC]/20 ml-3" data-id="element-210">
                                {category.subItems.map(subItem => <a key={subItem.name} href={subItem.href} className="flex items-center gap-2 px-3 py-2 text-sm text-slate-600 hover:text-[#0052CC] hover:bg-[#0052CC]/5 rounded-lg transition-colors" data-id="element-211">
                                    <ChevronRight className="h-3 w-3 text-[#0052CC]/50 flex-shrink-0" data-id="element-212" />
                                    {subItem.name}
                                  </a>)}
                              </div>
                            </div> : <a href={category.href} className="block px-3 py-2.5 text-sm font-medium text-slate-700 hover:text-[#0052CC] hover:bg-slate-50 rounded-lg transition-colors" data-id="element-213">
                              {category.name}
                            </a>}
                        </div>)}
                    </motion.div>}
                </AnimatePresence>
              </div>

              <div className="relative" onMouseEnter={() => setActiveDropdown('about')} onMouseLeave={() => setActiveDropdown(null)} data-id="element-214">
                <a href="/about" className={`flex items-center text-sm font-medium px-4 py-2 rounded-full transition-colors ${isActive('/about') || isActive('/team') ? 'bg-white text-[#0052CC] shadow-sm font-semibold' : 'text-slate-600 hover:text-[#0A1628]'}`} data-id="element-215">
                  About
                  <ChevronDown className="ml-1 h-3.5 w-3.5" data-id="element-216" />
                </a>

                <AnimatePresence data-id="element-217">
                  {activeDropdown === 'about' && <motion.div initial={{
                  opacity: 0,
                  y: 8
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: 8
                }} transition={{
                  duration: 0.15
                }} className="absolute top-full left-0 mt-2 w-52 bg-white shadow-xl border border-slate-200 rounded-xl overflow-hidden p-2 z-50" data-id="element-218">
                      <a href="/about" className="flex items-center gap-2 px-3 py-2.5 text-sm text-slate-700 hover:text-[#0052CC] hover:bg-[#0052CC]/5 rounded-lg transition-colors font-medium" data-id="element-219">
                        About Us
                      </a>
                      <a href="/team" className="flex items-center gap-2 px-3 py-2.5 text-sm text-slate-700 hover:text-[#0052CC] hover:bg-[#0052CC]/5 rounded-lg transition-colors font-medium" data-id="element-220">
                        Meet the Team
                      </a>
                      <a href="/policies" className="flex items-center gap-2 px-3 py-2.5 text-sm text-slate-700 hover:text-[#0052CC] hover:bg-[#0052CC]/5 rounded-lg transition-colors font-medium" data-id="element-221">
                        Policies
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </div>

              <a href="/services" className={`text-sm font-medium px-4 py-2 rounded-full transition-colors ${isActive('/services') ? 'bg-white text-[#0052CC] shadow-sm font-semibold' : 'text-slate-600 hover:text-[#0A1628]'}`} data-id="element-222">
                Sectors
              </a>

              {['Resources'].map(item => <a key={item} href="/resources" className={`text-sm font-medium px-4 py-2 rounded-full transition-colors ${isActive('/resources') ? 'bg-white text-[#0052CC] shadow-sm font-semibold' : 'text-slate-600 hover:text-[#0A1628]'}`} data-id="element-223">
                  {item}
                </a>)}
            </nav>

            {/* Right Actions */}
            <div className="flex items-center gap-3" data-id="element-224">
              {/* Search */}
              <div className="hidden md:flex" data-id="element-225">
                <div className="relative" data-id="element-226">
                  <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" data-id="element-227" />
                  <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} onFocus={() => setIsSearchFocused(true)} onBlur={() => setTimeout(() => setIsSearchFocused(false), 200)} placeholder="Search SKU, product, material..." className="w-56 pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-full text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0052CC]/20 focus:border-[#0052CC] focus:w-72 transition-all" data-id="element-228" />
                  {/* Search Results Dropdown */}
                  {showSearchResults && <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-slate-200 rounded-xl shadow-2xl overflow-hidden z-50 min-w-[320px]" data-id="element-229">
                      {searchResults.length > 0 ? <div className="max-h-80 overflow-y-auto" data-id="element-230">
                          {searchResults.map((result, i) => <a key={i} href={result.href} className="flex items-center justify-between px-4 py-3 hover:bg-slate-50 transition-colors border-b border-slate-50 last:border-0" data-id="element-231">
                              <div data-id="element-232">
                                <p className="text-sm font-medium text-[#0A1628]" data-id="element-233">
                                  {result.label}
                                </p>
                                <p className="text-[11px] text-slate-400" data-id="element-234">
                                  {result.category}
                                  {result.sku ? ` · SKU ${result.sku}` : ''}
                                </p>
                              </div>
                              <ChevronRight className="h-3.5 w-3.5 text-slate-300 flex-shrink-0" data-id="element-235" />
                            </a>)}
                        </div> : <div className="px-4 py-6 text-center" data-id="element-236">
                          <p className="text-sm text-slate-500" data-id="element-237">
                            No results for "{searchQuery}"
                          </p>
                          <p className="text-xs text-slate-400 mt-1" data-id="element-238">
                            Try a SKU number, material, or product name
                          </p>
                        </div>}
                    </div>}
                </div>
              </div>

              {/* Mobile Search Icon */}
              <button className="md:hidden p-2.5 text-slate-600 hover:text-[#0A1628] hover:bg-slate-100 rounded-full transition-colors" data-id="element-239">
                <Search className="h-5 w-5" data-id="element-240" />
              </button>

              {/* Order Now Button - Replaced Contact Us */}
              <a href="/order" className="hidden sm:flex items-center gap-2 px-4 py-2.5 bg-[#0A1628] text-white text-sm font-bold rounded-full hover:bg-[#0052CC] transition-colors" data-id="element-241">
                <ShoppingCart className="h-4 w-4" data-id="element-242" />
                <span className="hidden lg:inline" data-id="element-243">Order Now</span>
              </a>

              {/* User Account */}
              <a href="/account" className="p-2.5 text-slate-600 hover:text-[#0A1628] hover:bg-slate-100 rounded-full transition-colors" title="My Account" data-id="element-244">
                <User className="h-5 w-5" data-id="element-245" />
              </a>

              {/* Basket */}
              <a href="/basket" className="relative p-2.5 text-slate-600 hover:text-[#0A1628] hover:bg-slate-100 rounded-full transition-colors" title="Basket" data-id="element-246">
                <ShoppingBag className="h-5 w-5" data-id="element-247" />
                <span className="absolute -top-0.5 -right-0.5 h-4 w-4 bg-[#0052CC] text-white text-[10px] font-bold rounded-full flex items-center justify-center" data-id="element-248">
                  0
                </span>
              </a>

              {/* Mobile Menu Button */}
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2.5 text-slate-700 hover:bg-slate-100 rounded-full transition-colors" data-id="element-249">
                {isMobileMenuOpen ? <X className="h-5 w-5" data-id="element-250" /> : <Menu className="h-5 w-5" data-id="element-251" />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-252">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="fixed inset-0 top-[125px] bg-white z-40 px-6 py-6 overflow-y-auto lg:hidden border-t border-slate-100" data-id="element-253">
            <div className="flex flex-col space-y-1" data-id="element-254">
              {/* Mobile Search */}
              <div className="mb-4" data-id="element-255">
                <div className="relative" data-id="element-256">
                  <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" data-id="element-257" />
                  <input type="text" placeholder="Search products..." className="w-full pl-11 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0052CC]/20 focus:border-[#0052CC]" data-id="element-258" />
                </div>
              </div>

              {/* Products with sub-items */}
              <div className="border-b border-slate-100 pb-3 mb-2" data-id="element-259">
                <span className="text-lg font-semibold text-slate-900 py-3 block" data-id="element-260">
                  Products
                </span>
                <div className="space-y-2" data-id="element-261">
                  {/* Identification Labels with clear hierarchy */}
                  <div className="bg-slate-50 rounded-xl p-4" data-id="element-262">
                    <span className="text-sm font-bold text-[#0A1628] block mb-3" data-id="element-263">
                      Identification Labels
                    </span>
                    <div className="ml-2 border-l-2 border-slate-200 pl-4 space-y-2" data-id="element-264">
                      {productCategories[0].subItems?.map(item => <a key={item.name} href={item.href} className="flex items-center gap-2 text-base text-slate-600 py-1.5" data-id="element-265">
                          <ChevronRight className="h-3 w-3 text-slate-400" data-id="element-266" />
                          {item.name}
                        </a>)}
                    </div>
                  </div>
                  <a href="/products/nameplates" className="text-base font-medium text-slate-900 py-2 block" data-id="element-267">
                    Nameplates
                  </a>
                </div>
              </div>

              <a href="/services" className={`text-lg font-medium py-3 border-b border-slate-100 ${isActive('/services') ? 'text-[#0052CC] font-bold' : 'text-slate-900'}`} data-id="element-268">
                Services
              </a>

              <a href="/about" className={`text-lg font-medium py-3 border-b border-slate-100 ${isActive('/about') ? 'text-[#0052CC] font-bold' : 'text-slate-900'}`} data-id="element-269">
                About
              </a>

              {['Resources'].map(item => <a key={item} href="/resources" className="text-lg font-medium text-slate-900 py-3 border-b border-slate-100" data-id="element-270">
                  {item}
                </a>)}

              {/* Mobile phone number */}
              <a href="tel:01384243155" className="flex items-center gap-2 text-lg font-medium text-slate-900 py-3 border-b border-slate-100" data-id="element-271">
                <Phone className="h-5 w-5" data-id="element-272" />
                01384 243155
              </a>

              <a href="mailto:sales@industriallabels.co.uk" className="flex items-center gap-2 text-lg font-medium text-slate-900 py-3 border-b border-slate-100" data-id="element-273">
                <Mail className="h-5 w-5" data-id="element-274" />
                sales@industriallabels.co.uk
              </a>

              <div className="pt-6 space-y-3" data-id="element-275">
                <a href="/order" className="flex items-center justify-center gap-2 w-full py-3.5 bg-[#0052CC] text-white text-center font-bold rounded-xl" data-id="element-276">
                  <ShoppingCart className="h-4 w-4" data-id="element-277" />
                  Order Now
                </a>
                <a href="/products" className="block w-full py-3.5 bg-[#0A1628] text-white text-center font-bold rounded-xl" data-id="element-278">
                  Browse products
                </a>
                <button onClick={handleSampleClick} className="block w-full py-3.5 bg-slate-100 text-slate-700 text-center font-semibold rounded-xl hover:bg-slate-200 transition-colors" data-id="element-279">
                  Request a sample pack
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}